import { render, staticRenderFns } from "./EditMini.vue?vue&type=template&id=c39824c0&"
import script from "./EditMini.vue?vue&type=script&lang=js&"
export * from "./EditMini.vue?vue&type=script&lang=js&"
import style0 from "./EditMini.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports